export { BenchmarkGranularity } from "app/common/benchmark/constants";

export const BENCHMARKS_ENDPOINT = "api/benchmark";
export const BENCHMARK_USER_API = "/api/userdata/benchmark";
